import { string } from "yup";
import { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import { normalizeIdentifier } from "@utils/formatting";

export const siretValidation = (isRequired = false, countryPath = "country") => {
  const baseValidation = string().test("siret", "Le SIRET doit contenir 14 chiffres", function (value) {
    if (!value) return true;
    const country = this.parent?.[countryPath];
    if (country === SUPPORTED_COUNTRY.FRANCE) return /^\d{14}$/.test(normalizeIdentifier(value));
    return true;
  });

  return isRequired ? baseValidation.required("Le SIRET est requis") : baseValidation;
};
